module.exports = __webpack_public_path__ + "static/img/10.6629e95.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/10.png
// module id = Dt0/
// module chunks = 0